const AuthenticationHelpers = {
    urls: {
        login: (redirect?: string, autojoin?: { team: string; code: string }) => {
            const params = new URLSearchParams();

            if (redirect) {
                params.append('redirect', redirect);
            }

            if (autojoin) {
                params.append('team', autojoin.team);
                params.append('teamCode', autojoin.code);
            }

            const paramsAsString = params.toString();

            return paramsAsString ? `/login?${paramsAsString}` : '/login';
        },
        logout: () => '/logout',
    },

    loginRedirectPath: (pathname: string | null): string | undefined => {
        if (pathname !== '/login' || typeof window === 'undefined') return undefined;

        const redirect = new URLSearchParams(window.location.search).get('redirect');

        if (!redirect?.startsWith('/')) return undefined;

        try {
            return new URL(redirect, window.location.origin).pathname;
        } catch {
            return undefined;
        }
    },
};

export { AuthenticationHelpers };
